import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const RollbackGlyph = /*#__PURE__*/createElement("g", {
  id: "rollback"
}, /*#__PURE__*/createElement("path", {
  d: "M16.5 38.59L37 23.29c.8-.6 1.9-.7 2.7-.3s1.4 1.3 1.4 2.3v8.1c17.4 1.2 27.4 10.7 27.4 26.4 0 .7-.5 1.3-1.2 1.4-.7.2-1.4-.2-1.7-.8-.2-.4-5.2-11.1-24.6-11.6v7.3c0 1-.5 1.9-1.4 2.3s-1.9.3-2.7-.3l-20.4-15.3c-.6-.5-1-1.3-1-2.1 0-.9.4-1.6 1-2.1zm21.6 8.7c0-.8.7-1.5 1.5-1.5 14.2 0 21.8 5 25.5 8.9-2.6-15.1-16.8-18-25.6-18.4-.8-.1-1.4-.7-1.4-1.5v-8.9l-19.5 14.7 19.5 14.7v-8z"
}));
const Rollback = createSvg({
  name: 'rollback',
  path: RollbackGlyph
});

export default Rollback;
export { RollbackGlyph };
